import React, {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {observer} from "mobx-react-lite";
import {api} from "@source/api/http";
import nursingHomeStore from "@source/store/nursingHomeStore";
import {ConsentDocumentDetail} from "./consentDocumentDetail";
import {ConsentRequestState} from "@source/components/consentDocuments";
import ConsentDocumentsLayout from "../consentDocumentsLayout";

export const DocumentDetailPage = observer(() => {
  const location = useLocation();
  const requestedHomeId = new URLSearchParams(location.search).get("nursingHomeId") || "";
  const requestedHome = requestedHomeId
    ? nursingHomeStore.nursingHomes.find((home) => home._id === requestedHomeId)
    : undefined;
  const activeHomeId = nursingHomeStore.getId();
  const homeDenied = Boolean(requestedHomeId && nursingHomeStore.nursingHomes.length && !requestedHome);

  useEffect(() => {
    if (!requestedHome || requestedHome._id === nursingHomeStore.getId()) return;
    nursingHomeStore.setActiveNursingHome(requestedHome);
    nursingHomeStore.setLocalStorageActiveNursingHome(requestedHome._id);
    api.defaults.params = {...api.defaults.params, nursingHomeId: requestedHome._id};
  }, [requestedHome]);

  if (homeDenied) {
    return <ConsentDocumentsLayout><ConsentRequestState variant="error" title="No access" description="You do not have access to this nursing home."/></ConsentDocumentsLayout>;
  }
  if (requestedHome && requestedHome._id !== activeHomeId) {
    return <ConsentDocumentsLayout><ConsentRequestState variant="loading" title="Opening consent document"/></ConsentDocumentsLayout>;
  }

  const nursingHomeId = nursingHomeStore.getId();
  return <ConsentDocumentsLayout>{nursingHomeId
    ? <ConsentDocumentDetail key={nursingHomeId} nursingHomeId={nursingHomeId}/>
    : <ConsentRequestState variant="empty" title="Select a nursing home" description="Choose a nursing home to view this consent document."/>
  }</ConsentDocumentsLayout>;
});
